import React, { useEffect } from 'react';
import ReactGA from 'react-ga';
import { Route } from 'react-router-dom';

const GoogleAnalytics = props => {
  const { location: historyLocation, options } = props;

  // Log page changes
  useEffect(() => {
    const page = historyLocation.pathname + historyLocation.search;
    ReactGA.pageview(page);
  }, [historyLocation.pathname, historyLocation.search, options]);

  return null;
};

const RouteTracker = () => <Route component={GoogleAnalytics} />;

const trackingEnabled = window.env.GOOGLE_ANALYTICS_ENABLED === 'true';

const init = () => {
  if (trackingEnabled) {
    ReactGA.initialize('UA-20461003-21');
  }

  return trackingEnabled;
};

export default {
  RouteTracker,
  init,
  trackingEnabled,
  client: ReactGA
};
